export class ApiRequests{
    static GetBranches ="Grn/GetGrnBranches";
  //#region Authentication Routes
  public static Login: string = "Authentication/Login";
  public static VerifyTwoFactor: string = "Authentication/VerifyTwoFactor";
  public static ResendTwoFactorOtp: string = "Authentication/ResendTwoFactorOtp";
  //#endregion

  //#region User Management Routes
  public static UsersList: string = 'User/GetUsers';
  public static GetUserById: string = "User/GetUserById";
  public static UsersCreate: string = "User/CreateUser";
  //#endregion

  //#region Roles and Permissions Routes
  public static rolesCreate: string = 'Role/CreateRole';
  public static rolesUpdate: string = 'Role/UpdateRole';
  public static RolesList: string = "Role/GetRoles";
  public static RolesListPaged: string = "Role/GetRolesPaged";

  static PermissionList: string = "Role/GetRoleClaims";
  static ClaimList: string = "Role/GetClaims";
  static PermissionUserCreate: string = "Role/AssignClaimsToRole";
  //#endregion

  //#region SysproData
  public static SysproRoute ='SysproData';
  static GetStockItems: string= ApiRequests.SysproRoute+'/GetStockItems';
  static GetBuyers :string =ApiRequests.SysproRoute+"/GetBuyers"
  static GetCustomers :string =ApiRequests.SysproRoute+"/GetCustomers"
  static GetProductClasses :string =ApiRequests.SysproRoute+"/GetProductClasses"
  static GetStockItemInfo :string =ApiRequests.SysproRoute+"/GetStockItemInfo"
  static GetPoSupplierDetails :string =ApiRequests.SysproRoute+"/GetPoSupplierDetails"
  static GetPoSuppliers :string ="Supplier/GetSuppliersPaged"
  static GetPoSupplierLists :string =ApiRequests.SysproRoute+"/GetPoSuppliers"
  static GetTaxDetails :string =ApiRequests.SysproRoute+"/GetTaxDetails"
  static GetCompanyDetails: string = ApiRequests.SysproRoute + '/GetCompanyDetails';
  static GetApTerms: string = ApiRequests.SysproRoute + '/GetApTerms';
  static GetTaxCodes: string = ApiRequests.SysproRoute + '/GetTaxCodes';
  static GetCurrencies: string = ApiRequests.SysproRoute + '/GetCurrencies';
  static GetSupplierClasses: string = ApiRequests.SysproRoute + '/GetSupplierClasses';
  static GetBanks: string = ApiRequests.SysproRoute + '/GetBanks';
  static GetSalAreas: string = ApiRequests.SysproRoute + '/GetSalAreas';
  static GetNationalities: string = ApiRequests.SysproRoute + '/GetNationalities';
  static GetWarehouses :string =ApiRequests.SysproRoute+"/GetWarehouses" //TODO: Not a syspro request
  static GetUserWarehouses: string = "User/GetUserWarehouses";
  //static GetPoSuppliersPaged: string=ApiRequests.SysproRoute+"/GetPoSuppliers";

  static GetSuppliersPaged: string="Supplier/GetSuppliersPaged";

  //#region PurchaseOrder
  protected static PurchaseOrderRoute :string ="PurchaseOrder";
  static PostPurchaseOrderDetails: string=ApiRequests.PurchaseOrderRoute+"/CreatePurchaseOrderItem";
  static PurchaseOrderList: string=ApiRequests.PurchaseOrderRoute+"/GetPurchaseOrders";
  static PurchaseOrderCreate: string=ApiRequests.PurchaseOrderRoute+"/CreatePurchaseOrder";
  static PurchaseOrderDetails: string=ApiRequests.PurchaseOrderRoute+"/GetPurchaseOrderById";
  static GetPurchaseOrderItems: string=ApiRequests.PurchaseOrderRoute+"/GetPurchaseOrderItemsById";
  static DeletePurchaseOrder: string=ApiRequests.PurchaseOrderRoute+"/DeletePurchaseOrder";
  static PostPurchaseOrder: string=ApiRequests.PurchaseOrderRoute+"/PostPurchaseOrder";
  static UpdatePurchaseOrderItemDetails: string=ApiRequests.PurchaseOrderRoute+"/UpdatePurchaseOrderItem";
  static DeletePurchaseOrderItem: string=ApiRequests.PurchaseOrderRoute+"/DeletePurchaseOrderItem";
  static GetPoPdfPrintOut: string=ApiRequests.PurchaseOrderRoute+"/GeneratePdf";
  static PurchaseOrderUpdate: string=ApiRequests.PurchaseOrderRoute+"/UpdatePurchaseOrder";

  static SupplierNoteList: string="Supplier/GetSupplierNotesPaged";
  static SupplierExpiryDocumentPagedList: string="Supplier/GetSupplierExpiryDocumentsPaged";
  static GetSupplierInsights: string="SupplierInsights/GetInsights";
  static GetPoInsights: string="PoInsights/GetInsights";
  static GetPoExecSummary: string="PoExecSummary/GetSummary";
  static GetExecInsights: string="ExecInsights/GetInsights";
  static GetCashflowInsights: string="CashflowInsights/GetInsights";
  static GetCreatorDashboard: string="RoleDashboard/GetCreatorStats";
  static GetApproverDashboard: string="RoleDashboard/GetApproverStats";
  static GetCompanyDashboard: string="RoleDashboard/GetCompanyStats";
  static GetProcurementOverview: string="RoleDashboard/GetProcurementOverview";
  static GetMyApprovalQueue: string="RoleDashboard/GetMyApprovalQueue";
  static SupplierDocumentPagedList: string="Supplier/GetSupplierDocumentsPaged";
  static SupplierBridgeList: string="";
  static GetPoSuppliersPaged: string="Supplier/GetSupplierPaged";
  static GetDepartments: string="Department/GetDepartments";
  static UpdateUser: string="User/UpdateUser";

  //#region Holiday Mode / Approver Delegation
  protected static ApproverDelegationRoute: string = "ApproverDelegations";
  static CreateApproverDelegation: string = ApiRequests.ApproverDelegationRoute + "/CreateDelegation";
  static RevokeApproverDelegation: string = ApiRequests.ApproverDelegationRoute + "/RevokeDelegation";
  static GetActiveApproverDelegationsForUser: string = ApiRequests.ApproverDelegationRoute + "/GetActiveDelegationsForUser";
  static GetActiveDelegationsForDelegate: string = ApiRequests.ApproverDelegationRoute + "/GetActiveDelegationsForDelegate";
  static GetAllActiveApproverDelegations: string = ApiRequests.ApproverDelegationRoute + "/GetAllActiveDelegations";
  static SupportGetAllActiveDelegations: string = 'ApproverDelegations/GetAllActiveDelegations';
  //#endregion
  static DeleteUser: string="User/DeleteUser";
  static GetUserByToken: string="User/GetCurrentUser";

  static GetCurrentUser: string="";
  static GetTenantList: string="TenantData/GetAll";
  static GetTenantMenuMappings: string="TenantData/GetMenus";
  static GetSupplierDetails: string="Supplier/GetSupplierDetails";
  //#region Supplier Routes
  static PostSupplierNotes: string = "Supplier/CreateSupplierNote";
  static DeleteSupplierNote: string = "Supplier/DeleteSupplierNote";
  static UpdateSupplierNotes: string = "Supplier/UpdateSupplierNote";
  static SupplierContactList: string = "Supplier/GetSupplierContactsPaged";
  static PostSupplierContact: string = "Supplier/CreateSupplierContact";
  static UpdateSupplerContact: string = "Supplier/UpdateSupplierContact";
  static DeleteSupplierContact: string = "Supplier/DeleteSupplierContact";
  static PostSupplierDocument: string = "Supplier/CreateSupplierDocument";
  static DeleteSupplierDocument: string = "Supplier/DeleteSupplierDocument";
  static PostSupplierCredit: string = 'Supplier/CreateSupplierCreditLimit';
  static GetSupplierCredit: string = 'Supplier/GetCreditLimitBySupplier';
  static SupplierSummary: string = 'Supplier/GetSupplierPurchases';
  //#endregion

  //#region Purchase Order Document Routes
  static PurchaseOrderDocumentList: string = "PurchaseOrder/GetPurchaseOrderDocumentsPaged";
  static PostPurchaseOrderDocument: string = "PurchaseOrder/CreatePurchaseOrderDocument";
  static DeletePurchaseOrderDocument: string = "PurchaseOrder/DeletePurchaseOrderDocument";
  //#endregion

  //#region Support Service Routes
  static SupportSupplierPODocuments: string = "Supplier/GetPODocumentsPaged";
  static SupportPurchaseOrderList: string = "PurchaseOrder/GetPaged";
  static SupportPurchaseOrderUpdate: string = "PurchaseOrder/Update";
  static SupportMonthlyReport: string = "PurchaseOrder/MonthlyReport";
  static SupportPrCreators: string = "PurchaseOrder/GetPrCreators";
  static SupportGrnPaged: string = "Grn/GetPaged";
  static SupportGrnGetById: string = "Grn/GetById";
  static SupportGrnGetByPoNo: string = "Grn/GetByPoNo";
  static SupportGrnGetReversals: string = "Grn/GetReversals";
  static SupportGrnValidateReversal: string = "Grn/ValidateReversalItem";
  static SupportGrnValidate: string = "Grn/ValidateGrn";
  static SupportSavePoItem: string = "PurchaseOrder/SaveItem";
  static SupportDeletePoItem: string = "PurchaseOrder/DeleteItem";
  static SupportInvalidatePoCache: string = "PurchaseOrder/InvalidateCache";
  static SupportRejectPo: string = "PurchaseOrder/Reject";
  static SupportGetUser: string = "User/GetUser";
  static SupportGetUsersPaged: string = "User/GetUsers";
  static SupportGetUserClaims: string = "User/GetClaims";
  static SupportGetRolesPaged: string = "Role/GetRolesPaged";
  static SupportGetRoles: string = "Role/GetRoles";
  static SupportGetDepartmentsPaged: string = "Department/GetDepartmentsPaged";
  static SupportGetDepartments: string = "Department/GetDepartments";
  static SupportDeleteDepartment: string = "Department/DeleteDepartment";
  static SupportSupplierOnboardingGetPaged: string = "SupplierOnboarding/GetPaged";
  static SupportSupplierOnboardingGetById: string = "SupplierOnboarding/GetById";
  static SupportSupplierOnboardingSendApprovalEmails: string = "SupplierOnboarding/SendApprovalEmails";
  static SupportSupplierOnboardingGetDocuments: string = "SupplierOnboarding";
  static SupportSupplierOnboardingGetActiveEditRequest: string = "SupplierOnboarding/GetActiveEditRequest";
  static SupportSupplierOnboardingCreateEditRequest: string = "SupplierOnboarding/CreateEditRequest";
  static SupportSupplierOnboardingGetActiveStatuses: string = "SupplierOnboarding/GetActiveOnboardingStatuses";
  static SupportSupplierOnboardingGetSettings: string = "SupplierOnboardingSettings/GetSettings";
  static SupportSupplierOnboardingSaveSettings: string = "SupplierOnboardingSettings/SaveSettings";
  static SupportSupplierOnboardingGetActivityLogs: string = "SupplierOnboarding/GetActivityLogs";
  static SupportSupplierOnboardingGetFieldChangeLogs: string = "SupplierOnboarding/GetFieldChangeLogs";
  static SupportDocumentTypeGetAll: string = "DocumentType/GetAll";
  static SupportGetTenantDetails: string = "TenantDetail/GetTenantDetails";
  static SupportUpdateTenantDetails: string = "TenantDetail/UpdateTenantDetails";
  static SupportUpdateAddressDetails: string = "TenantDetail/UpdateAddressDetails";
  static SupportUpdateGeneralSettings: string = "TenantDetail/UpdateGeneralSettings";
  static SupportSendApprovalNotification: string = "PurchaseOrder/SendApprovalNotification";
  static SendPolicyBasedEmails: string = "PurchaseOrder/SendPolicyBasedEmails";
  static SupportApprovePurchaseOrder: string      = "PurchaseOrder/Approve";
  static SupportUpdateApprovalComment: string    = "PurchaseOrder/UpdateApprovalComment";
  static SupportGetContactPricing: string = "Syspro/GetContactPricing";
  static SupportInvalidateFullCache: string = "Cache/InvalidateFullCache";
  static SupportGetPoDetail: string = "PurchaseOrder/GetDetail";
  static SupportGetPoItemsEditStatus: string = "PurchaseOrder/GetPoItemsEditStatus";
  static SupportGetUserWarehouses: string = "User/GetUserWarehouses";
  static SupportGetActivityLogs: string = "PurchaseOrder/GetActivityLogs";
  static SupportGetWarehouses: string = "Syspro/GetWarehouses";
  static SupportGetOpenPoItemsPaged: string = "Syspro/GetOpenPoItemsPaged";
  static SupportCreatePurchaseOrder: string = "PurchaseOrder/Create";
  static SupportDuplicatePurchaseOrder: string = "PurchaseOrder";
  static SupportPurchaseOrderDocumentList: string = "PurchaseOrder";
  static SupportBulkImportPurchaseOrder: string = "PurchaseOrder/BulkImport";
  static SupportUpdatePurchaseOrderHeader: string = "PurchaseOrder/UpdateHeader";
  static SupportGetInbox: string = "PurchaseOrder/GetInbox";

  // Contract Reports
  static SupportGetContractProgressReport: string = "ContractReport/GetContractProgressReport";
  static SupportGetActiveContracts: string   = "ContractReport/GetActiveContracts";
  static SupportGetContractList: string      = "ContractReport/GetContractList";
  static SupportGetJobAnalysis: string       = "ContractReport/GetJobAnalysis";
  static SupportGetJobCostDetail: string     = "ContractReport/GetJobCostDetail";
  static SupportGetOutstandingJobs: string   = "ContractReport/GetOutstandingJobs";
  static SupportGetSalesDetail: string       = "ContractReport/GetSalesDetail";
  static SupportGetExcessBillings: string    = "ContractReport/GetExcessBillings";
  static SupportGetContractDashboard: string = "ContractReport/GetContractDashboard";
  static SupportGetGrnByHier: string         = "ContractReport/GetGrnByHier";
  static SupportGetContractNotes: string     = "ContractNote/GetNotes";
  static SupportAddContractNote: string      = "ContractNote/AddNote";
  //#endregion

  //#region User Account Routes
  static ResetUserPassword: string = "User/ResetUserPassword";
  static UpdateUserPassword: string = "User/UpdateUserPassword";
  static ResetPassword: string = "User/ForgotPassword";
  static UserValidateOTP: string = "User/VerifyResetPasswordOtp";
  static UserResetPassword: string = "User/ResetPassword";
  //#endregion

  //#region Department Routes
  static DepartmentList: string = "Department/GetDepartmentsPaged";
  static PostDepartments: string = "Department/CreateDepartment";
  static UpdateDepartments: string = "Department/UpdateDepartment";
  static DeleteDepartment: string="Department/DeleteDepartment";
  static SupportGetDepartmentGlMappings: string = "Department";   // append /{id}/gl-mappings
  static SupportPutDepartmentGlMappings: string = "Department";   // append /{id}/gl-mappings
  static SupportGetAllGlItems: string = "Department/all-gl-items";
  //#endregion

  //#region GL Controls
  static SupportGetNonStockItems: string = "Syspro/GetNonStockItems";
  //#endregion

  private static ApprovalPolicy: string = "PoPolicyRange/";
  static ApprovalPolicyList: string=this.ApprovalPolicy+"GetPaged";
  static GetPolicyList: string=this.ApprovalPolicy+"GetAll";
  static PostApprovalPolicy: string=this.ApprovalPolicy+"Create";
  static UpdateApprovalPolicy: string=this.ApprovalPolicy+"Update";
  static DeleteApprovalPolicy: string=this.ApprovalPolicy+"Delete";
  static SendPoForApproval: string="PurchaseOrder/SendForApproval";
  static ApprovePurchaseOrder: string="PurchaseOrder/ApprovePo";
    static GetSupplierPurchaseOrders: string="PurchaseOrder/GetSupplierPurchaseOrders";
    static DeleteRole: string="Role/DeleteRole";
    static GetRoles: string="Role/GetRoles";
    static RejectPurchaseOrder: string="PurchaseOrder/RejectPo";
  static GetMyTasks: string = ApiRequests.SupportGetInbox;

    static GetPurchaseOrderByPoNo: string="PurchaseOrder/GetPurchaseOrderByPoSerialNo";
    static CreateTenant: string='TenantData/Create';
    static GetTenant: string="TenantData/GetById";
  static UpdateTenant: string="TenantData/Update";
  static TenantMenuAssign: string="TenantData/AssignTenantMenu";
  static GetTenantDetails: string="TenantDetail/GetTenantDetails";
  static UpdateTenantDetails: string="TenantDetail/UpdateTenantDetails";
  static UploadLogo: string="TenantDetail/UploadLogo";
  static UploadPoWatermark: string="TenantDetail/UploadPoWatermark";
  static UploadGrnWatermark: string="TenantDetail/UploadGrnWatermark";
  static CreateDatabase: string="TenantDetail/CreateDatabase";
  static GetAvailablePostedPurchaseOrders: string="Grn/GetOpenPos";
  static GetPurchaseGrn: string="Grn/GetOpenPoItems";
  static PostGrn: string="Grn/CreateGrn";
  static PostGrnFile: string="Grn/CreateGrnDoc";
  static GetGrnById: string="Grn/GetGrnById";
  static PostGrnItems: string="Grn/CreateGrnItem";
    static ProcessGRN: string="Grn/ProcessGrn";
  static GetGrnPaged: string="Grn/GetGrnsPaged";
  static GetOpenPurchaseOrders: string="Grn/GetOpenPoItemsPaged";
  static GetGrnPdf: string="Grn/GeneratePdf";

  static GetInventoryPaged ="Inventory/GetInventoryPaged";
  static GetInventorySummaryPaged ="Inventory/GetInventorySummaryPaged";
  static GetMovementPaged:string ="Inventory/GetInventoryMovementPaged" ;
 // static UserList =""

  //#region Job Routes
  static jobs = {
    getAll: "Job/GetJobsPaged",
    getById: "Job/GetJob",
    create: "Job/CreateJob",
    update: "Job/UpdateJob",
    delete: "Job/DeleteJob",
    getItems: "Job/GetJobItems",
    saveItem: "Job/SaveJobItem",
    getFiles: "Job/GetJobFiles",
    uploadFile: "Job/UploadJobFile",
    deleteFile: "Job/DeleteJobFile",
    processJob: "Job/ProcessJob"
  }
  static GetHierarchyJobs: string = "Job/GetJobHiers";
  //#endregion
    static SendGrnEmail: string="Grn/SendGrnEmail";
    static GetPreviousGRN: string="Grn/GetPoGrns";
  static GetTenantMenuSettings: string='TenantData/GetMenuSettings';
    static CheckPoItemEdit: string='PurchaseOrder/GetPoItemEditStatus';
    static GetPoGrnStatus: string='Grn/GetPoGrnStatus';
  static GetPoStatus: string="PurchaseOrder/GetPoStatus";
    static GetActivityLog: string="TenantDetail/GetEntityActivityLogs";
    static DeleteGrnDocument: string="Grn/DeleteGrnDoc";
  static SalesOrderQuery: string='SalesOrder/GetSalesOrdersPaged';
  static SalesOrder: string='SalesOrder/GetSalesOrder';
    static GetMonthlyOrders: string="PurchaseOrder/GetMonthlyPoCounts";
  static SuppliersCount: string="Supplier/GetSupplierCount";
    static SupplierPayments: string='Supplier/GetSupplierPaymentsPaged';
  static SupplierPaymentsSummary: string='Supplier/GetSupplierPayments';
  static GetPosStatus: string="PurchaseOrder/GetPosStatus";
  static SendPoEmailError: string="PurchaseOrder/SendPoErrorEmail";
  static GetSysproLogs: string="SysproLog/GetSysproLogsPaged";
  static GetSysproLogsByEntiryId: string="SysproLog/GetSysproLogsByEntityId";
    static SendGrnErrorEmail: string="Grn/SendGrnErrorEmail";
  static GetPoItemsStatus: string="PurchaseOrder/GetPoItemsEditStatus";
    static UpdateGrnItems: string="Grn/UpdatePOEditedItems";
    static SendPoEmail: string="PurchaseOrder/SendPoEmail";
   static GetTenantPaged: string="TenantData/GetTenantsPaged";
    static GetPoAnalysis: string="PurchaseOrder/GetPoAnalysis";
    static GetPoSysproAnalysis: string="PurchaseOrder/GetPoTotalsToDate";
    static GetPurchaseOrderClients: string="PurchaseOrder/GetPrCreators";
    static GetUserNotifications: any='PurchaseOrder/GetUserNotifications';
    static CheckConnectionIsGood: string='TenantDetail/ValidateTenantSysproDbConn';
    static TestSysproConfigs: string='TenantDetail/TestSysproConfigs';
    static TestSysproPoSuppliers: string='TenantDetail/TestSysproPoSuppliers';
    static PurchaseOrdersEscalate: string='PurchaseOrder/EscalatePos';
    static SubscriptionsCreate: string='Subscription/Create';
  static SubscriptionsList: string='Subscription';
  static SubscriptionsUpdate: string='Subscription/Update';
  static SubscriptionRangesCreate: string='Subscription/Range/Create';
  static SubscriptionRangesGet: string='Subscription/SubscriptionRanges';
  static SubscriptionRangesUpdate: string='Subscription/Range/Update';
  static TenantSubscriptionsCreate: string='Subscription/Tenant/Create';
  static SubscriptionsTenant: string='Subscription/TenantSubscriptions';
  static TenantSubscriptionsUpdate: any='Subscription/Tenant/Update';
  static PostTenantNotes: string = "TenantData/Notes";
  static UpdateTenantNotes: string="TenantData/Notes";
  static TenantNoteList: string="TenantData/Notes";
  static DeleteTenantNote: string="TenantData/Notes";
    static GetTenantLinkList: string="TenantData/GetLinkedTenants";
  static SaveTenantLink: string='TenantData/LinkTenant';
  static DeleteTenantLink: string='TenantData/DeleteTenantLink';
  static TestSysproCredentials: string='SysproData/TestSysproCredentials';
    static GetOpenJobs: string='Job/GetJobsOpen';
    static GetJobSections: string='Job/GetJobHiersSection1';
    static SendUserInvite: string='User/InviteNewUserEmail';
    static AllocatePoItemJob: string="PurchaseOrder/AllocatePoItemsJob";
    static AllocateGrnItems: string="Grn/IssueGrnJobItems";
    static GetPoApprovers: string='User/GetLevelOneApprovers';
    static GetApprovers: string = 'User/GetApprovers';
    static DeletePoJobAllocation: string='PurchaseOrder/DeletePoJobAllocation';
    static ReverseGrnItem: string='Grn/ReverseGrnItem';
  static GetGrnReversals: string='Grn/GetGrnReversalItemsV1';
    static SendPoApprovalEmail: string="PurchaseOrder/SendPoApprovalEmail";
    static SendForApprovalEmail: string="PurchaseOrder/SendForApprovalEmail";
  static GetPendingAvailable: string="PurchaseOrder/GetPendingAvailable";
    static SendTestEmail: string="TenantDetail/TestTenantSmtp";
    static GetReversalPDF: string="Grn/GenerateReversedItemPdfV1";
    static SendGrnReversalEmail: string="Grn/SendGrnReversalEmail";

  //#region Supplier Onboarding
  private static SupplierOnboardingRoute: string = 'SupplierOnboarding';
  static SupplierOnboardingGetPaged: string = ApiRequests.SupplierOnboardingRoute + '/GetPaged';
  static SupplierOnboardingGetById: string = ApiRequests.SupplierOnboardingRoute + '/GetById';
  static SupplierOnboardingCreate: string = ApiRequests.SupplierOnboardingRoute + '/Create';
  static SupplierOnboardingUpdate: string = ApiRequests.SupplierOnboardingRoute + '/Update';
  static SupplierOnboardingSaveDraft: string = ApiRequests.SupplierOnboardingRoute + '/SaveDraft';
  static SupplierOnboardingSendForApproval: string = ApiRequests.SupplierOnboardingRoute + '/SendForApproval';
  static SupplierOnboardingApprove: string = ApiRequests.SupplierOnboardingRoute + '/Approve';
  static SupplierOnboardingReject: string = ApiRequests.SupplierOnboardingRoute + '/Reject';
  static SupplierOnboardingCancel: string = ApiRequests.SupplierOnboardingRoute + '/Cancel';
  static SupplierOnboardingDelete: string = ApiRequests.SupplierOnboardingRoute + '/Delete';
  static SupplierOnboardingPostToSyspro: string = ApiRequests.SupplierOnboardingRoute + '/PostToSyspro';
  static SupplierOnboardingGetSysproXml: string = ApiRequests.SupplierOnboardingRoute + '/GetSysproXml';
  static SupplierOnboardingGetActivityLogs: string = ApiRequests.SupplierOnboardingRoute + '/GetActivityLogs';
  static SupplierOnboardingGenerateUploadLink: string = ApiRequests.SupplierOnboardingRoute + '/GenerateUploadLink';
  static SupplierOnboardingRevokeUploadLink: string   = ApiRequests.SupplierOnboardingRoute + '/RevokeUploadLink';
  static SupplierOnboardingUploadLinkStatus: string   = ApiRequests.SupplierOnboardingRoute + '/GetUploadLinkStatus';
  static SupplierOnboardingUpsertFormData: string     = ApiRequests.SupplierOnboardingRoute + '/UpsertFormData';
  static SupplierPublicUploadValidate: string  = 'SupplierUpload/ValidateToken';
  static SupplierPublicUpload: string          = 'SupplierUpload/UploadDocument';
  static SupplierPublicUploadNotify: string    = 'SupplierUpload/NotifyComplete';
  static SupplierPublicSaveFormData: string    = 'SupplierUpload/SaveFormData';
  static SupplierPublicSaveDraft: string       = 'SupplierUpload/SaveDraft';
  //#endregion

  //#region Document Type
  private static DocumentTypeRoute: string = 'DocumentType';
  static DocumentTypeGetPaged: string = ApiRequests.DocumentTypeRoute + '/GetPaged';
  static DocumentTypeGetAll: string = ApiRequests.DocumentTypeRoute + '/GetAll';
  static DocumentTypeCreate: string = ApiRequests.DocumentTypeRoute + '/Create';
  static DocumentTypeUpdate: string = ApiRequests.DocumentTypeRoute + '/Update';
  static DocumentTypeDelete: string = ApiRequests.DocumentTypeRoute + '/Delete';
  //#endregion

  //#region Custom Field Definitions
  static SupportCustomFieldDefinitions: string = 'CustomFieldDefinitions/GetAll';
  static CustomFieldDefinitionGetById: string = 'CustomFieldDefinitions/GetCustomFieldDefinitionById';
  static CustomFieldDefinitionCreate: string = 'CustomFieldDefinitions/CreateCustomFieldDefinition';
  static CustomFieldDefinitionUpdate: string = 'CustomFieldDefinitions/UpdateCustomFieldDefinition';
  static CustomFieldDefinitionDelete: string = 'CustomFieldDefinitions/DeleteCustomFieldDefinition';
  static SysproExecuteDropdownQuery: string = 'SysproData/ExecuteDropdownQuery';
  static SysproTestDropdownQuery: string = 'SysproData/TestDropdownQuery';
  //#endregion

  //#region Invoice Routes (SupportService — always prefix with environment.supportBaseUrl)
  static SupportInvoiceTemplatePaged: string = 'InvoiceTemplate';
  static SupportInvoiceGetPaged: string  = 'Invoice/GetPaged';
  static SupportInvoiceGetById: string   = 'Invoice/GetById';
  /** Append /{supplierCode}/upload */
  static SupportInvoiceUpload: string    = 'Invoice';
  static SupportInvoiceConfirm: string   = 'Invoice/Confirm';
  static SupportInvoiceReject: string    = 'Invoice/Reject';
  /** Use as: Invoice/{id}/pdf */
  static SupportInvoiceGetPdf: string    = 'Invoice';
  /** Append /{id} — DELETE */
  static SupportInvoiceDelete: string    = 'Invoice';
  //#endregion

}
